import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, CanLoad, Route, UrlSegment, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import jwt_decode from 'jwt-decode';

import { AuthenicationService } from '../_services/authenication.service';

interface Token {
  users_usertype: string;
}
@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanActivateChild, CanLoad {

  usersTypeList: any[] = ['admin','subadmin','supersubadmin','employee','employee1','employee2','employee3'];

  constructor(
    private router: Router,
    private authenticationService: AuthenicationService
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    let url: string = state.url;
    return this.checkLogin(url);
  }
  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.canActivate(next, state);
  }
  canLoad(
    route: Route,
    segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
      let url: string = `/${route.path}`;
      return this.checkLogin(url);
  }

  checkLogin(url: string): boolean {

    if (this.authenticationService.isLoggedIn()) {
      let userData = this.authenticationService.getJwtToken();
      try{
        const decoded = jwt_decode<Token>(userData);
        if (this.usersTypeList.includes(decoded.users_usertype) == true) {
            return true;
        }
        else{
          this.authenticationService.logoutUser();
          this.router.navigate(['/login']);
          return false;
        }
      }
      catch (err) {
        this.authenticationService.logoutUser();
        this.router.navigate(['/login']);
        return false;
      }

    }
    else{
      // this.authenticationService.logoutUser();
      this.router.navigate(['/login']);
      this.authenticationService.redirectUrl = url;
      return false;
    }

  }
}
